import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useMapViewConfig = () =>
  useQuery<crmModels.IMapViewConfig>({
    queryKey: [crmConstants.queryKeys.MAP_VIEW_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/map-view-config');

      return res?.data?.data;
    },
    staleTime: Infinity
  });
